import React, { ReactElement } from 'react';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardDatePickerProps,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Control, Controller } from 'react-hook-form';
import useStyles from '../styles';

interface IDatePickerProps
  extends Omit<KeyboardDatePickerProps, 'onChange' | 'value'> {
  control: Control;
  rules: any;
  name: string;
  handleChange?: (data: Date | null | string) => void;
  controllerExtras?: any;
}

export default function DatePicker(props: IDatePickerProps): ReactElement {
  const {
    control,
    rules,
    handleChange,
    controllerExtras = {},
    ...other
  } = props;
  const classes = useStyles();
  var defaultInputProps = {
    classes: {
      notchedOutline: classes.notchedOutline,
    },
  };

  // const convertToUtc = (date: Date) => {
  //   console.log(
  //     new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
  //   );
  //   return date;

  //   return new Date(
  //     Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  //   );
  // };

  return (
    <Controller
      render={({ onChange, value }) => (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            disableToolbar
            onChange={(date, value) => {
              // const utcDate = convertToUtc(date as Date);
              handleChange && handleChange(date);
              onChange(date, value);
            }}
            InputProps={{
              ...(defaultInputProps as any),
              ...other.InputProps,
            }}
            {...other}
            format={other.format || 'dd-MM-yyyy'}
            variant={other.variant || 'inline'}
            inputVariant={other.inputVariant || 'outlined'}
            value={value}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
        </MuiPickersUtilsProvider>
      )}
      name={other.name}
      rules={rules}
      control={control}
      {...controllerExtras}
    />
  );
}
